<template>
  <div class="wary  mdx-flex">
    <div class="logobox mdx-flex">
      <img class="leftimg"
        src="../../static/images/loginLeftImg.png">
      <div class="rightbox">
        <div class="topLines">
          <template v-if="loginIdentity==1">
            <div v-if="loginType==3" class="wzk-flex-1 w-m-l-30">
              <i class="el-icon-back" style="font-size: 30px;color: #888;" @click="loginType=1"></i>
            </div>
            <div class="" style="margin-right: 80px;">
              <el-button type="primary" size="small" @click="loginTypeCheck()" v-if="loginType!=3">
                {{loginType==1?'微信登录':'验证码登录'}}
              </el-button>
            </div>
            <img src="../../static/images/codeLoin.png" v-if="loginType!=2" @click="loginTypeCheck()">
            <img src="../../static/images/ptLogin.png" v-else @click="loginTypeCheck()">
          </template>
        </div>
        <div class="mdx-center-lg mdx-text-center" style="margin-top: 40px;margin-bottom: 30px;" v-if="loginType==3">
          <h3>微信授权成功，请绑定手机号</h3>
        </div>
        <div class="mdx-center-lg" style="margin-top: 40px;margin-bottom: 30px;" v-else-if="loginType==1">
          <h3>{{loginIdentity==2?'员工登录':loginType==1?'验证码登录':'微信登录'}}</h3>
        </div>

        <template v-if="loginType==1">
          <el-form :model="loginFrom" ref="logoFrom">
            <el-form-item v-if="loginIdentity==1">
              <div class="mdx-center-lg inputBox">
                <el-input v-model="loginFrom.mobile" :maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')"
                  placeholder="手机号"></el-input>
              </div>
            </el-form-item>
            <el-form-item v-else>
              <div class="mdx-center-lg inputBox">
                <el-input v-model="loginFrom.username" placeholder="账号"></el-input>
              </div>
            </el-form-item>
            <el-form-item v-if="loginIdentity==2">
              <div class="mdx-center-lg inputBox">
                <el-input v-model="loginFrom.password" :maxlength="18" type="password" show-password placeholder="密码">
                </el-input>
              </div>
            </el-form-item>
            <el-form-item v-else>
              <div class="mdx-center-lg inputBox">
                <el-input v-model="loginFrom.code" onkeyup="value=value.replace(/[^\d]/g,'')" :maxlength="6"
                  placeholder="验证码"></el-input>
                <div class="codeBox wzk-cursor" @click.stop='sendSms'>{{codetext}}
                </div>
              </div>
            </el-form-item>
            <div class="dengluBot mdx-center-lg">
              <el-button type="primary" style="width: 100%;border-radius: 50px;" @click="loginBtns">登录
              </el-button>
            </div>
          </el-form>
        </template>
        <template v-if="loginType==2">
          <div class="mdx-text-center w-m-t-20">
            <wxlogin appid="wxa4d88247803ff3be" :scope="'snsapi_login'"
              :redirect_uri='encodeURIComponent($store.state.callback+"/login")' rel="external nofollow">
            </wxlogin>
          </div>
        </template>
        <template v-if="loginType==3">
          <el-form :model="loginFrom" ref="logoFrom">
            <el-form-item v-if="loginIdentity==1">
              <div class="mdx-center-lg inputBox">
                <el-input v-model="loginFrom.mobile" :maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')"
                  placeholder="手机号"></el-input>
              </div>
            </el-form-item>
            <el-form-item v-else>
              <div class="mdx-center-lg inputBox">
                <el-input v-model="loginFrom.username" placeholder="账号"></el-input>
              </div>
            </el-form-item>
            <div class="mdx-center-lg inputBox">
              <el-input v-model="loginFrom.code" onkeyup="value=value.replace(/[^\d]/g,'')" :maxlength="6"
                placeholder="验证码"></el-input>
              <div class="codeBox wzk-cursor" @click.stop='sendSms'>{{codetext}}
              </div>
            </div>
            <div class="dengluBot mdx-center-lg">
              <el-button type="primary" style="width: 100%;border-radius: 50px;" @click="mobileBingding">绑定
              </el-button>
            </div>
          </el-form>
        </template>
        <div class="check mdx-center-lg mdx-flex" style="margin-top: 30px;" v-if="loginType==1">
          <el-checkbox-group v-model="checkList" style="margin-top: 5px;">
            <el-checkbox label=""></el-checkbox>
          </el-checkbox-group>
          <div style="margin-left: 10px;font-size: 14px;">
            我已阅读并同意 <span @click="$mHelper.to('/xieyi?type=1')">《中一鼎合造价众包平台用户协议》</span> 和 <span
              @click="$mHelper.to('/xieyi?type=2')">《中一鼎合造价众包平台隐私协议》</span>
          </div>
        </div>
        <div class="logoTypes mdx-text-center wzk-cursor" @click="IdentityCheck()" v-if="loginType==1">
          {{loginIdentity==1?'员工登录':'普通登录'}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import wxlogin from 'vue-wxlogin';
  export default {
    components: {
      wxlogin
    },
    data() {
      return {
        checkList: [],
        loginType: 1, //手机号登录 2验证码登录
        loginIdentity: 1, //1普通用戶登錄 2员工登录
        loginFrom: {
          username: '',
          password: '',
          code: '',
          mobile: '', //手机号
        },
        codeSeconds: 0, // 验证码发送时间间隔
        codetext: '获取验证码',
        openId: '',
        wxLoginCode: ''
      }
    },
    head: {
      script: [{
        src: "http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"
      }]
    },
    mounted() {
      // var obj = new WxLogin({
      //   id: "weixin",
      //   appid: "wx3bdb1192c22883f3",
      //   scope: "snsapi_login",
      //   redirect_uri: "http://domain/weixinlogin"
      // });
    },
    created() {
      let data = this.$route.query
      if (data.code) {
        this.$http.post('/auth/LoginByWeChat', {
          pcCode: data.code
        }).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.$message.success('登录成功')
            this.$store.commit('changeLogin', {
              token: res.data.token,
              userInfo: res.data.userInfo
            })
            this.$mHelper.to('/')
          }
          if (res.code == 1001) {
            this.openId = res.data;
            this.loginType = 3
          } else {
            this.loginType = 2
          }
        })
      }
    },
    methods: {
      topage() {
        alert(1)
      },

      //點擊登錄
      loginBtns() {
        if (this.checkList.length < 1) {
          this.$message.error('请阅读并同意勾选《中一鼎合造价众包平台用户协议》和《中一鼎合造价众包平台隐私协议》')
          return
        }
        if (this.loginIdentity == 1) {
          console.log('普通用戶登錄');
          let checkSendCode = this.$mGraceChecker.check(this.loginFrom, this.$mFormRule.ptLogin);
          if (!checkSendCode) {
            this.$message.error(this.$mGraceChecker.error)
            return;
          }
          this.$http.post('/auth/loginByMobile', this.loginFrom).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '登录成功',
                offset: 60,
                type: 'success',
                showClose: true,
              });
              // this.$message.success('登录成功')
              this.$store.commit('changeLogin', {
                token: res.data.token,
                userInfo: res.data.userInfo
              })
              if(res.data.userInfo.identity == 2){
                localStorage.setItem('changeType',2)
              }else if(res.data.userInfo.identity == 1){
                localStorage.setItem('changeType',1)
              }
              this.$mHelper.to('/')
            }
            if (res.code == 4003) {
              console.log('请完成个人资料后登录');
              this.$message.warning('请完成个人资料后登录')
              this.$mHelper.to('/fillInfo?uuid=' + res.data.uuid + '&mobile=' + res.data.userName + '&identity=' +
                res.data.identity)
            }
          })
        } else {
          let checkSendCode = this.$mGraceChecker.check(this.loginFrom, this.$mFormRule.ygLogin);
          if (!checkSendCode) {
            this.$message.error(this.$mGraceChecker.error)
            return;
          }
          this.$http.post('auth/loginByUsername', this.loginFrom).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '登录成功',
                offset: 60,
                type: 'success',
                showClose: true,
              });
              //this.$message.success('登录成功')
              this.$store.commit('changeLogin', {
                token: res.data.token,
                userInfo: res.data.userInfo
              })
              if(res.data.userInfo.identity == 2){
                localStorage.setItem('changeType',2)
              }else if(res.data.userInfo.identity == 1){
                localStorage.setItem('changeType',1)
              }
              this.$mHelper.to('/')
            }
            if (res.code == 4003) {
              console.log('请完成个人资料后登录');
              this.$message.warning('请完成个人资料后登录')
              this.$mHelper.to('/fillInfo?uuid=' + res.data.uuid + '&mobile=' + res.data.mobile + '&identity=' +
                res.data.identity)
            }
          })
        }
      },
      //微信登绑定手机号
      mobileBingding() {
        let checkSendCode = this.$mGraceChecker.check(this.loginFrom, this.$mFormRule.ptLogin);
        if (!checkSendCode) {
          this.$message.error(this.$mGraceChecker.error)
          return;
        }
        this.$http.post('auth/bindMobile', {
          openId: this.openId,
          code: this.loginFrom.code,
          mobile: this.loginFrom.mobile
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('登录成功')
            this.$store.commit('changeLogin', {
              token: res.data.token,
              userInfo: res.data.userInfo
            })
            this.$mHelper.to('/')
          }
          if (res.code == 4003) {
            console.log('请完成个人资料后登录');
            this.$message.warning('请完成个人资料后登录')
            this.$mHelper.to('/fillInfo?uuid=' + res.data.uuid + '&mobile=' + res.data.userName + '&identity=' +
              res.data.identity)
          }
        })
      },
      //发送验证码
      sendSms() {
        if (this.codeSeconds > 0) {
          return;
        }
        let checkSendCode = this.$mGraceChecker.check(this.loginFrom, this.$mFormRule.sendCodeRule);
        if (!checkSendCode) {
          this.$message.error(this.$mGraceChecker.error)
          return;
        }
        this.$http.post('sms/sendCode', this.loginFrom).then(res => {
          if (res.code == 200) {
            this.$message.success('验证码发送成功，请注意查收')
            this.handleSmsCodeTime(59);
          }
        })
      },
      //验证码倒计时
      handleSmsCodeTime(time) {
        let timer = setInterval(() => {
          if (time <= 0) {
            clearInterval(timer);
            this.codeSeconds = 0;
            this.codetext = '再次发送';
          } else {
            this.codeSeconds = time;
            this.codetext = time;
            time--;
          }
        }, 1000);
      },
      IdentityCheck() {
        this.loginIdentity = this.loginIdentity == 1 ? 2 : 1
        if (this.loginIdentity == 1) {
          this.loginType = 1
        }
        this.$refs['logoFrom'].resetFields();
      },
      loginTypeCheck() {
        this.loginType = this.loginType == 1 ? 2 : 1
        this.$refs['logoFrom'].resetFields();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .check {
    span {
      color: #185BA1;
      cursor: pointer;
    }
  }

  .logoTypes {
    margin-top: 20px;
    color: #185BA1;
  }

  .dengluBot {
    margin-top: 80px;
  }

  .inputBox {
    // margin-top: 30px;

    ::v-deep .el-input__inner {
      border-radius: 50px;
      background-color: #eee;
    }

    position: relative;

    .codeBox {
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      border-left: 1px solid #ddd;
      text-align: center;
      height: 30px;
      top: 5px;
      line-height: 30px;
      color: #666;
    }
  }

  .topLines {
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    img {
      position: absolute;
      width: 80px;
      height: 80px;
      top: 0;
      cursor: pointer;
    }
  }

  .wary {
    min-height: calc(100% - 60px);
    width: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    padding: 50px 0;
    box-sizing: border-box;
  }

  .logobox {
    border-radius: 10px;
    overflow: hidden;
    height: 550px;
    width: 960px;
    margin: auto;
    background-color: #fff;
  }

  .leftimg {
    width: 480px;
    height: 550px;
  }

  .rightbox {
    height: 550px;
    position: relative;
    width: 480px;
  }
</style>
